// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function(it){
  return Object(defined(it));
};


//////////////////
// WEBPACK FOOTER
// /app/node_modules/core-js/library/modules/_to-object.js
// module id = 173
// module chunks = 0